import { useQuery } from "@tanstack/react-query";

import { HTTP_BASE } from "@app/config/axios";
import { useAuthentication } from "@app/store/useAuthtentication";

import type { IResponse } from "@app/common/types/http";
import type { IAccount } from "@app/store/types";

const fetchAccounts = async (idUser: number, token: string) => {
  const response = await HTTP_BASE(token).get<{ accounts: IAccount[] } & IResponse>(
    `/security/user/accountsByUser/${idUser}`
  );
  return response.data;
};

export const useGetAccounts = (idUser: number, authToken?: string, enabled = true) => {
  const token = useAuthentication((state) => state.auth.dataBiowel.token);

  const query = useQuery({
    refetchOnWindowFocus: false,
    queryKey: ["accounts", idUser],
    enabled,
    queryFn: async () => await fetchAccounts(idUser, authToken ?? token)
  });

  return query;
};
